(function (root, factory) {
  const api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root) root.AttakyBuildRuntime = api;
})(typeof window !== 'undefined' ? window : null, function () {
  'use strict';

  function resolveEditionKey(editions, requested, aliases = {}) {
    if (!requested) return null;
    const direct = editions.find(edition => edition.handle === requested || edition.previewHandle === requested || edition.key === requested);
    if (direct) return direct.key;
    const legacyKey = Object.prototype.hasOwnProperty.call(aliases, requested) ? aliases[requested] : null;
    return editions.some(edition => edition.key === legacyKey) ? legacyKey : null;
  }

  function editionAvailability(variants) {
    const priced = (variants || []).filter(variant => Number(variant.price) > 0);
    if (!priced.length) return 'unavailable';
    return priced.some(variant => variant.available) ? null : 'soldout';
  }

  function initialStepForDeepLink({ hasDeepLink, hasValidBuild }) {
    if (!hasDeepLink) return null;
    return hasValidBuild ? 'color' : 'build';
  }

  function createLatestRetryLoader(rawLoad, options = {}) {
    const delays = options.delays || [250, 750, 1500];
    const schedule = options.schedule || setTimeout;
    let generation = 0;

    function load(url, handlers = {}) {
      const requestGeneration = ++generation;
      let attempt = 0;

      const run = () => {
        if (requestGeneration !== generation) return;
        rawLoad(
          url,
          value => {
            if (requestGeneration === generation && handlers.onSuccess) handlers.onSuccess(value);
          },
          progress => {
            if (requestGeneration === generation && handlers.onProgress) handlers.onProgress(progress);
          },
          error => {
            if (requestGeneration !== generation) return;
            if (attempt < delays.length) {
              const delay = delays[attempt++];
              schedule(run, delay);
              return;
            }
            if (handlers.onError) handlers.onError(error);
          },
        );
      };

      run();
      return requestGeneration;
    }

    function cancel() {
      generation += 1;
    }

    return { load, cancel };
  }

  return { initialStepForDeepLink, createLatestRetryLoader, resolveEditionKey, editionAvailability };
});
